/**
 * Keeps the browser from discarding the GPU context on `webglcontextlost`.
 * Unity's teardown then has a context to restore instead of reading `GLctx`
 * on an already-deleted handle.
 */
export function attachWebGlContextGuard(canvas: HTMLCanvasElement): () => void {
  const onContextLost = (event: Event) => {
    event.preventDefault();
  };

  canvas.addEventListener("webglcontextlost", onContextLost, false);

  return () => {
    canvas.removeEventListener("webglcontextlost", onContextLost, false);
  };
}
